// Webpack Polyfill Injector
function main() {
    require("./Resources/private/js/index.js");
    require("./Resources/private/scss/styles.scss");
    require("bootstrap-loader");
}
if (function() {
    return /* Array.prototype.@@iterator */ !("Symbol"in self&&"iterator"in self.Symbol&&!!Array.prototype[self.Symbol.iterator]
) ||
        /* Array.prototype.indexOf */ !("indexOf"in Array.prototype
) ||
        /* CustomEvent */ !("CustomEvent"in self&&("function"==typeof self.CustomEvent||self.CustomEvent.toString().indexOf("CustomEventConstructor")>-1)
) ||
        /* Element.prototype.closest */ !("document"in self&&"closest"in document.documentElement
) ||
        /* Element.prototype.remove */ !("Element"in self&&"remove"in Element.prototype
) ||
        /* NodeList.prototype.forEach */ !("forEach"in NodeList.prototype
) ||
        /* Number.parseInt */ !("parseInt"in Number&&8===Number.parseInt("08")
) ||
        /* Object.assign */ !("assign"in Object
) ||
        /* Promise */ !("Promise"in self
) ||
        /* String.prototype.endsWith */ !("endsWith"in String.prototype
) ||
        /* String.prototype.includes */ !("includes"in String.prototype
) ||
        /* String.prototype.startsWith */ !("startsWith"in String.prototype
) ||
        /* Symbol */ !("Symbol"in self&&0===self.Symbol.length
) ||
        /* Symbol.iterator */ !("Symbol"in self&&"iterator"in self.Symbol
) ||
        /* URL */ !((function(e){"use strict"
try{var a=new e.URL("http://example.com")
if("href"in a&&"searchParams"in a){var r=new URL("http://example.com")
if(r.search="a=1&b=2","http://example.com/?a=1&b=2"===r.href&&(r.search="","http://example.com/"===r.href)){var t=new e.URLSearchParams("a=1"),c=new e.URLSearchParams(t)
if("a=1"===String(c))return!0}}return!1}catch(h){return!1}})(self)
);
}.call(window)) {
    var js = document.createElement('script');
    js.src = "js/script.js";
    js.onload = main;
    js.onerror = function onError(message) {
        console.error('Could not load the polyfills: ' + message);
    };
    document.head.appendChild(js);
} else {
    main();
}